var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_12757_10701",
    transform: "scale(0.0333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_12757_10701",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEWklEQVR4nLVXWYhdRRAd98R9wTVuKIoBtyDqh6C4xA3XgH4kH3FforjghxLFiAtxASG4g+iHCjKgH0GGzNw+p+8st+pN8ohG4kZQo8QN97jFqBk5/fqGmXFmMjMZGxr6dVXfU9V1qqpfW9skRgM4wch5Bsz1EI6fzDcmNBrAuUa+58BfDnzg5IdO/m3k6oo8u+3/GEZea+SfRj7UXxT71PtaO/CIZB7jVVMKWpXlrAQKXJGMKMvjnLxXU+u0B1zp5IYqxmOnDNjINwx4Ja/nZc87jezKBs2VzIFXDXh9SkDb29u3c+D3BnBWjHGakT87cHUtr4BrtNfR0bGT4uzALwOLFm271cAewv5ODizv7j4ks/mf1e3tO9ZyrbUnmXSkW3V27rfVwM1mcwcDNlZFcbKIZMCmvhhPrOUN8iTtSSYd6Q42bKuGk91GLtLayBcM+MSB6x242cnPHHg+yx40oLdtqkaDvMHJdfIkxri9A/cY2dR08m7tpfgDX1kIN00ZcIxxmpNfKJdH03FygZFfN5cu3XlSIAMDA9t4Wc70EGZbjOekuWzZ3hbCHUZ+JO+GnxGjDfjUgDv7gCOV72mGcHl/URw9Hs92VX6qDIqdOXV+cPIuM5tuwJfybPg5Ixemazab7sBj6UyeYryTb8q4UYGNfEK1uBHjwQ68rVgOlotMBnzb29u7V72nFDLy15EM0qiAwxxYoyo3FvAqIz9WCjXIS438rq+vb7fBxcSAFQYs2WwM2S6SSTbSN1VMxHoje0YFdnJtuuIYr1OsM3MXDvEg56qTp6pS6SothFNGAlT9NuD9pEOuGhNYVy2iKHWqGC9y8vtGR8fuQ24GeNqBd5Mu+ex/yAnMyfKfHHhAJXbLwCHc6uQ3Rt6Y9/oduG+w3judnbvkuK2tQ5FuKISLHVjpwHq1z5oLapdbBJZ1icXA5ylNYjxf7GwWxR5DdMtyZhXjMWkdwgVOLleDMHJx3a9TWpKvjeuqBawioNSpyFvyfmXk/cP1leNOmpG/Ofl4T0/PvtpPWdECVMt8OTkyHuC8vk1lMpVCAQA/xhj3TIDkGWKp2qWTT6qDDTGoxZO3vCyPSt8C5owbOJfJdU7enj9GBwoDogN/KKWa3d0HStbX1XVQ/RLJ5FpfxXjZ5u9iAsD59wJducqkemwqMMDDFsKMJI/xcAdeTI+/VqVbnM89pfBMGtha76iB/hgPGKzXWxSH5va40UhUwOlGzpcBqVaHMEO3ono/IeCqLGc5uVSgda9NhoQww4Bn0osSKAVYy/IVrzTypWz0ktrr8QKv0YsixZM8TfuKZfqQYkv2NEI4c8TzwCW11zqTyBfC7C0CZzauqAEV18TaFnsrsXvUw3URaZ1PXqezrVScr7Qby+PndHB5URyhvFTXMaBRkeeNBTjM6wtrr5VmOcfXGvDoqIfyv4KVKbatuaF+4kxoApvUPtXpEh/IanCXG3GoJarr6J01FVMEHKll/gtHMNLmHJ9DXAAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.232a0033.svg";
export { ForwardRef as ReactComponent };